import { render, staticRenderFns } from "./BenefitCodeLowStockBanner.vue?vue&type=template&id=2d791791&"
import script from "./BenefitCodeLowStockBanner.vue?vue&type=script&lang=js&"
export * from "./BenefitCodeLowStockBanner.vue?vue&type=script&lang=js&"
import style0 from "./BenefitCodeLowStockBanner.vue?vue&type=style&index=0&id=2d791791&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports